/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { groupBy, orderBy, capitalize } from 'lodash';
import Check from '../Check';
import noop from '../../utils/noop';

import './styles.css';

class Checklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'required',
      showSuccessChecks: { required: false, recommended: false }
    };

    this.setActive = this.setActive.bind(this);
    this.toggleSuccessChecks = this.toggleSuccessChecks.bind(this);
  }

  setActive(group) {
    return event => {
      if (event) {
        event.preventDefault();
      }

      this.props.Metrics.track(`click:sc:tenant:productioncheck:${group}`);
      this.setState({ activeTab: group });
    };
  }

  toggleSuccessChecks(group) {
    return event => {
      if (event) {
        event.preventDefault();
      }
      const { showSuccessChecks } = this.state;

      this.setState({
        showSuccessChecks: {
          ...showSuccessChecks,
          [`${group}`]: !showSuccessChecks[group]
        }
      });
    };
  }

  printGroupTitle(group) {
    if (
      group === 'bestpractice' ||
      group === 'bestpractices' ||
      group === 'suggested'
    ) {
      return 'Best Practices';
    }
    return capitalize(group);
  }

  renderBadge(checklist) {
    const failedChecklist =
      checklist &&
      checklist.filter(
        check => check.result === 'fail' || check.result === 'error'
      );
    const failedChecklistLen = failedChecklist && failedChecklist.length;

    if (failedChecklistLen >= 1) {
      return (
        <span className="badge badge-danger badge-square badge-small badge-top">
          {failedChecklistLen}
        </span>
      );
    }

    return null;
  }

  renderSummaryMessage(group, failedChecklistLen, successChecklistLen) {
    if (
      group === 'bestpractice' ||
      group === 'bestpractices' ||
      group === 'suggested'
    ) {
      return (
        <p>
          These actions cannot be verified automatically, please check them manually.
        </p>
      );
    } else if (failedChecklistLen && successChecklistLen) {
      return (
        <p >{`${failedChecklistLen} checks failed and ${successChecklistLen} passed.`}</p>
      );
    } else if (failedChecklistLen) {
      return <p>{`${failedChecklistLen} checks failed.`}</p>;
    } else if (successChecklistLen) {
      return <p>{`${successChecklistLen} checks passed.`}</p>;
    }
    return null;
  }

  render() {
    const {
      clientList,
      checklist,
      checklistResult,
      groups,
      groupByIdentifier,
      Metrics
    } = this.props;

    const { activeTab, showSuccessChecks } = this.state;

    let checklistMergedWithResults = checklist;

    if (checklistResult && checklistResult.length >= 1) {
      checklistMergedWithResults = checklist.map(check => {
        const checkResult = checklistResult.find(
          result => result.checkName === check.name
        );

        const checkResultDetails =
          checkResult &&
          checkResult.details.map(detail => {
            const client = clientList.find(
              cli => cli.value === detail.clientId
            );

            return {
              ...detail,
              clientName: client && client.label
            };
          });

        return {
          ...check,
          result: checkResult && checkResult.result ? checkResult.result : null,
          details: checkResultDetails,
          hasResult: !!(checkResult && checkResult.result),
          clientListTotal: (clientList && clientList.length) || 0,
          runned: true
        };
      });
    }

    const checklistGrouped = groupBy(
      checklistMergedWithResults,
      groupByIdentifier
    );

    return (
      <div className="checklist">
        <ul className="nav nav-tabs">
          {groups.map(group => (
            <li
              key={group}
              className={classNames({ active: activeTab === group })}
            >
              <a
                style={{ fontSize: '16px' }}
                href="#"
                onClick={this.setActive(group)}
              >
                {this.printGroupTitle(group)}{' '}
                {this.renderBadge(checklistGrouped[group])}
              </a>
            </li>
          ))}
        </ul>
        {groups.map(group => {
          const checklist = checklistGrouped[group];

          const failedChecklist =
            checklist &&
            checklist.filter(
              check => check.result === 'fail' || check.result === 'error'
            );

          const failedChecklistLen = failedChecklist && failedChecklist.length;

          const successChecklist =
            checklist && checklist.filter(check => check.result === 'success');
          const successChecklistLen =
            successChecklist && successChecklist.length;

          const readChecklist =
            checklist &&
            checklist.filter(
              check =>
                check.result !== 'fail' &&
                check.result !== 'error' &&
                check.result !== 'success'
            );

          return (
            <div
              key={group}
              className={classNames('checklist-group', {
                hidden: activeTab !== group
              })}
            >
              {this.renderSummaryMessage(
                group,
                failedChecklistLen,
                successChecklistLen
              )}

              {failedChecklist && (
                <ul>
                  {orderBy(
                    failedChecklist,
                    ['applies_to'],
                    ['desc']
                  ).map(check => (
                    <Check key={check.name} {...check} Metrics={Metrics} />
                  ))}
                </ul>
              )}

              {readChecklist && (
                <ul>
                  {readChecklist.map(check => (
                    <Check key={check.name} {...check} />
                  ))}
                </ul>
              )}

              {successChecklist && successChecklistLen ? (
                <div>
                  <div className="check check-border-top">
                    <div className="row">
                      <div className="col-sm-1">
                        <i className="check-icon check-icon--pass icon-budicon-500" />
                      </div>
                      <div className="col-sm-11">
                        <div className="check-header">
                          <strong className="check-title">{`${successChecklistLen} Check${successChecklistLen >
                          1
                            ? 's'
                            : ''} Passed`}</strong>{' '}
                          <a
                            className="check-link check-link--show"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="#"
                            onClick={this.toggleSuccessChecks(group)}
                          >
                            {showSuccessChecks[group] ? (
                              'Hide details'
                            ) : (
                              'Show details'
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul
                    className={classNames({
                      hidden: !showSuccessChecks[group]
                    })}
                  >
                    {successChecklist.map(check => (
                      <Check key={check.name} {...check} />
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

Checklist.propTypes = {
  checklist: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  groupByIdentifier: PropTypes.string.isRequired,
  checklistResult: PropTypes.array,
  showLinks: PropTypes.bool,
  clientList: PropTypes.array,
  Metrics: PropTypes.object
};

Checklist.defaultProps = {
  Metrics: { track: noop }
};

export default Checklist;
